import { render, staticRenderFns } from "./EnergyArt.vue?vue&type=template&id=3b013dfe&"
import script from "./EnergyArt.vue?vue&type=script&lang=js&"
export * from "./EnergyArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports